import { render } from "./TopActiveInstitutions.vue?vue&type=template&id=3f498cf6"
import script from "./TopActiveInstitutions.vue?vue&type=script&lang=js"
export * from "./TopActiveInstitutions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__